export function getAuthHeader() {
    return { 'Authorization': 'Basic ' + window.btoa(process.env.REACT_APP_USECASEAPICREDENTIALS) };
}

export default getAuthHeader;